export const launchMessages = [
  { emoji: '⛏️', text: 'Mining for digital gold' },
  { emoji: '📦', text: 'Virtual crates, real sweat' },
  { emoji: '🏃', text: 'Chasing the perfect beat' },
  { emoji: '💣', text: 'Weaponized FOMO engaged' },
  { emoji: '⭐', text: 'Your next favorite track' },
  { emoji: '⏭️', text: 'Skip or keep?' },
  { emoji: '💎', text: 'Unearthing sonic gems' },
  { emoji: '➰', text: 'Loops, beats, and FOMO' },
  { emoji: '📜', text: 'Scrolling for soul' },
  { emoji: '➕', text: 'One more track...' },
  { emoji: '🌀', text: 'Lost in the groove' },
  { emoji: '🕵️', text: 'Finding hidden rhythms' },
  { emoji: '⚡', text: 'Electronic dreams loading' },
  { emoji: '🎨', text: 'Curating your vibe' },
  { emoji: '🔪', text: 'Fresh cuts incoming' },
  { emoji: '⏳', text: 'Infinite scroll, finite time' },
  { emoji: '🔊', text: 'Bassline hunt in progress' },
  { emoji: '🎹', text: 'Synths are warming up' },
  { emoji: '💓', text: 'BPM matching your heart' },
  { emoji: '🚜', text: 'Digging through the noise' },
  { emoji: '✨', text: 'Only the good stuff' },
  { emoji: '🏺', text: 'Rare grooves pending' },
  { emoji: '👂', text: 'Your ears will thank' },
  { emoji: '🛶', text: 'Avoiding the mainstream' },
  { emoji: '🤿', text: 'Deep dive starting' },
  { emoji: '🚀', text: 'Sonic exploration ahead' },
  { emoji: '🏷️', text: 'Just one more sub-genre' },
  { emoji: '🔁', text: 'Looping into the future' },
  { emoji: '🧹', text: 'Crate digging, no dust' },
  { emoji: '📡', text: 'Frequency check... 1, 2' },
  { emoji: '⌚', text: 'Where did time go?' },
  { emoji: '🥊', text: 'All killer, no filler' },
  { emoji: '☝️', text: "That's the one. Maybe." },
  { emoji: '🎯', text: 'Your rhythm, our mission' },
  { emoji: '🚇', text: 'Exploring the underground' },
  { emoji: '🎧', text: 'High fidelity, deep pockets' },
  { emoji: '🔔', text: "Don't miss this one" },
  { emoji: '👤', text: 'Strictly for the heads' },
  { emoji: '📻', text: 'Tuned to your taste' },
  { emoji: '💃', text: 'Rhythm is a dancer' },
  { emoji: '☕', text: 'Trading sleep for beats' },
  { emoji: '🛰️', text: 'Activating discovery mode' },
  { emoji: '🔍', text: 'Searching for the 1' },
  { emoji: '🥁', text: 'Beyond the 4/4 beat' },
  { emoji: '🏭', text: 'Warehouse vibes loading' },
  { emoji: '💾', text: 'Analog soul, digital heart' },
  { emoji: '🚫', text: 'Trust the algorithm? Never.' },
  { emoji: '🖐️', text: 'Manual digging is better' },
  { emoji: '🔥', text: 'Found another banger' },
  { emoji: '🎬', text: 'Your soundtrack starts now' },
]
